'use client';

import {Globe} from '@dev-landing//img/icons/globe';
import Link from 'next/link';
import {usePathname} from 'next/navigation';

import styles from './SwitchLanguageComponent.module.scss';

const SLICE_COUNT = 3;

export default function SwitchLanguageComponentPrevVersion() {
  const router = usePathname() as string;

  const generateButtonPath = (locale: string) => {
    if (router.startsWith('/en') || router.startsWith('/zh')) {
      return `/${locale}${router.slice(SLICE_COUNT) || '/'}`;
    }

    return `/${locale}${router || '/'}`;
  };

  const availableLanguages = [
    {
      lang: 'ru',
      label: 'Русский',
      available: router.startsWith('/en') || router.startsWith('/zh'),
      href: `${router.slice(SLICE_COUNT) || '/'}`,
      testId: 'switch_button_lang_ru_id',
    },
    {
      lang: 'en',
      label: 'English',
      available: !router.startsWith('/en'),
      href: generateButtonPath('en'),
      testId: 'switch_button_lang_en_id',
    },
    {
      lang: 'zh',
      label: '简体中文',
      available: !router.startsWith('/zh'),
      href: generateButtonPath('zh'),
      testId: 'switch_button_lang_zh_id',
    },
  ];

  return (
    <div className={styles.container}>
      {availableLanguages.map(
        ({lang, label, available, href, testId}) =>
          available && (
            <Link
              key={lang}
              className={styles.button}
              href={href}
              data-testid={testId}
            >
              <Globe />
              {label}
            </Link>
          ),
      )}
    </div>
  );
}
